import { render, staticRenderFns } from "./FormGenerator.vue?vue&type=template&id=0dbf1806&scoped=true&"
import script from "./FormGenerator.vue?vue&type=script&lang=js&"
export * from "./FormGenerator.vue?vue&type=script&lang=js&"
import style0 from "./FormGenerator.vue?vue&type=style&index=0&id=0dbf1806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbf1806",
  null
  
)

export default component.exports